import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import siteConfig from "../../config/site";

const API_URL = siteConfig.apiUrl;

const Login = () => {
  const [checking, setChecking] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    // Check if already logged in
    fetch(`${API_URL}/auth/checkauth`, { credentials: "include" })
      .then(r => r.json())
      .then(data => {
        if (data.authenticated) {
          if (data.role === "admin") window.location.href = "/admin";
          else if (data.role === "performer") window.location.href = "/profile";
          else window.location.href = "/";
        }
        setChecking(false);
      })
      .catch(() => setChecking(false));

    // Check for error in URL
    const params = new URLSearchParams(window.location.search);
    if (params.get("error")) {
      setError("Sign in failed. Please try again.");
    }
  }, []);

  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}/auth/google`;
  };

  if (checking) {
    return (
      <div className="bg-[#0a0a0f] min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-purple-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="bg-[#0a0a0f] min-h-screen">
      <div className="h-20" />

      <section className="py-20 px-6">
        <div className="max-w-md mx-auto">
          {/* Brand */}
          <div className="text-center mb-10">
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-2">
              Team Login
            </h1>
            <div className="w-16 h-0.5 bg-gradient-to-r from-purple-700 to-gold mx-auto mb-4" />
            <p className="text-gray-500 text-sm font-body">
              For Exo Entertainment performers &amp; admin.
            </p>
          </div>

          {/* Error */}
          {error && (
            <div className="mb-6 p-3 rounded-lg bg-red-900/30 border border-red-800/50 text-red-400 text-sm text-center">
              {error}
            </div>
          )}

          {/* Google Sign In */}
          <button
            onClick={handleGoogleLogin}
            className="w-full flex items-center justify-center gap-3 py-3 px-6 bg-white text-gray-800 font-semibold text-sm rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign in with Google
          </button>

          <p className="text-center text-gray-600 text-xs mt-6">
            Only authorized team members can sign in.
          </p>

          {/* Footer links */}
          <div className="text-center mt-8 space-y-3">
            <p className="text-gray-600 text-xs">
              Interested in joining our team?{" "}
              <Link to="/hiring" className="text-purple-400 hover:text-purple-300 transition-colors">
                Apply here
              </Link>
            </p>
            <p className="text-gray-700 text-xs">
              <Link to="/" className="hover:text-gray-500 transition-colors">
                ← Back to site
              </Link>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Login;
